import { Alert, Card, CardContent, CardHeader } from "@mui/material";
import DownloadPDFButtons from "../general/DownloadPDFButtons";
import { RememberMe, StickyNote2 } from "@mui/icons-material";
import PDFKartuPeserta from "../PDF/PDFKartuPeserta";
import { useRef } from "react";
import PDFUndangan from "../PDF/PDFUndangan";
import { STATUS_PROGRESS } from "../../helper/Constant";
import PDFCommon from "../PDF/PDFCommon";

function DetailUndangan({ data_santri, dataBerkas }) {
    const kartuPesertaRef = useRef();
    const suratUndangaRef = useRef();

    const GenerateContent = () => {
        if (data_santri.status === STATUS_PROGRESS.UNDANGAN_UJIAN) {
            const buttonsConfig = [
                {
                    label: 'Kartu Peserta Ujian',
                    icon: RememberMe,
                    ref: kartuPesertaRef,
                    pdfComponent: PDFCommon,
                    fileName: `kartu-peserta-${data_santri.no_daftar}.pdf`,
                    data: { dataSantri: data_santri, templateKey: 'kartu_peserta' },
                    orientation: 'landscape'
                },
                {
                    label: 'Surat Undangan',
                    icon: StickyNote2,
                    ref: suratUndangaRef,
                    pdfComponent: PDFCommon,
                    fileName: `surat-undangan-${data_santri.no_daftar}.pdf`,
                    data: { dataSantri: data_santri, templateKey: 'undangan' },
                }
            ];

            return (
                <>
                    Download berkas-berkas berikut untuk dicetak dan dibawa saat pelaksanaan Test/Ujian.
                    <DownloadPDFButtons buttons={buttonsConfig}></DownloadPDFButtons>
                </>
            )
        }
        return (
            <>
                <Alert title="Undagan Belum dapat dilihat" variant="filled" severity="warning" sx={{ marginBottom: "15px" }}>
                    Undangan baru dapat dilihat jika semua berkas sudah lengkap, sudah membayar biaya pendaftaran, dan sudah dijadwalkan oleh panitia.
                    Jika sudah lengkap, undangan insya Allah dapat didownload pada bagian ini setelah 3-7 hari.
                </Alert>
            </>
        )
    };

    return (
        <>
            <Card>
                <CardHeader title="Undangan Seleksi" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    {GenerateContent()}
                </CardContent>
            </Card>

        </>
    )
}

export default DetailUndangan;